export class DefineContributionRequest {

  constructor() {
    this.MemberAssignedPlans = new Array<any>();
    this.BundlePlans = new Array<BundlePlans>();
  }

  Id: number;
  QuoteId: number;
  CarrierId: number;
  OrionCarrierId: string;
  PackageRulesInstanceId: number;
  Carrier: string;
  PackageName: string;
  RAF: number = 1;
  EffectiveDate: string;
  BundleTypeId: number;
  PayPeriodTypeId: number;
  Order: number;
  DefaultPlanId: string;
  BundleName: string;
  QuoteName: string;
  HasWrappedCarrier: boolean;
  IsBestProviderPackage: boolean;
  WrappedBundle: any;
  BundleHasRolledPlans: boolean;
  EmployerContribution: EmployerContribution;
  QuotePackage: QuotePackage;
  MemberAssignedPlans: any[];
  BundlePlans: BundlePlans[];
  QuoteMembers: ContributionMember[];
  
}

export class EmployerContribution {
  Id: number;
  ContributionAmountTypeId: number;
  EmployerContributionTypeId: number;
  EmployeeContributionPercent: number;
  EmployeeContributionAmount: number;
  DependentContributionPercent: number;
  DependentContributionAmount: number;
  IsRollExcess: boolean = false;
  EmployerSelectedPlan: string;
  EmployerSelectedPlanId: string;
  IsEEPaysAllDependentAmount: boolean = true;
  OOSEmployerContributions: any[];
}
export class OOSEmployerContribution {
  BundleId: number;
  MemberId: number;
  EmployerSelectedPlanId: number;
  EmployeeContributionPercent: number;
  EmployeeContributionAmount: number;
  DependentContributionPercent: number;
  DependentContributionAmount: number;
  IsEEPaysAllDependentAmount: boolean = false;
}
export class QuotePackage {
  Id: number;
  OrionPackageId: number;
  PackageId: number;
  PackageName: string;
  CarrierId: number;
  OrionCarrierId: string;
  CarrierName: string;
  FromDate: string;
  ToDate: string;
  IsActiveForWebQuoting: boolean;
  IsActiveForQuoting: boolean;
  IsDeleted: boolean;
  StateCode: string;
}

export class BundlePlans {
  Id: number;
  BundleId: number;
  NQSPlanId: number;
  //PlanId: number;
  TotalPremium: number;
  Order: number;
  NQSCarrierId: number;
  RolledOverBundlePlanId: string;
  OrionPlanId: string;
  QuotePlan: QuotePlan;
  PremiumRates: PremiumRates[];
  BundlePlanRatingAreas: BundlePlanRatingAreas[]
  CalculateNewHireAgeAsOfMemberEffectiveDate: boolean;
}

export class QuotePlan {
  Id: number;
  OrionPlanId: string;
  IntegrationPlanId: string;
  Name: string;
  MediumName: string;
  Network: string;
  BenefitType: string;
  RollToPlanId: string;
  MetalTierType: string;
}

export class PremiumRates {
  Id: number;
  BundlePlanId: number;
  Value: string;
  MemberId: number;
  Premium: number;
  IsEmployeeCovered: boolean;
  IsEmpTobaccoUser: boolean;
  DependentPremium: number;
  ERPays: number;
  EEPays: number;
  EECost: number;
  DECost: number;
  ERPaysForEE: number;
  ERPaysForDE: number;
}

export class BundlePlanRatingAreas {
  Id: number;
  BundlePlanId: number;
  Value: string;
  MemberId: number;
  RatingArea: string;
  NQSPlanId: number;
}

export class ContributionMember {
  Id: number;
  MemberId: number;
  ZipCode: string;
  CountyCode: string;
  BirthDate: string;
  Age: number;
  EnrollmentEffectiveDate:string;
  StateId: number;
  IsTobaccoUser: boolean;
  IsLifeOnly: boolean;
  IsCobra: boolean;
  Dependents: ContributionDependent[];

  //other props
  FirstName: string;
  LastName: string;
  DOB: string;
  GenderTypeId: number;
  MemberTypeId: number = 1;
  PostalCodesList: any = [];
  TempCountyCodesList: any = null;
  State: string = 'CA';
  Salary: number = 0;
  JobTitle: string = '';
  IsMedicare: boolean = false;
  IsTobacco: boolean = false;
  IsEmployerZipCode: boolean = true;
  IncludeMedical: boolean = true;
  IncludeDental: boolean = false;
  IncludeVision: boolean = false;
  IncludeLife: boolean = false;
  IsDisabled: boolean = false;
  DependentStatus: boolean = false;
  ParentId: number = null;
  Order: number = 0;
  QuoteId: number = 0;
  memberIndex: string = '';
  childIndex: string = '';
  TempZipCode: string = '';
  CreatedBy: number = 320212;
  CreatedDate: Date;
  UpdatedBy: number = 320212;
  UpdatedDate: Date;
  Premium: number;

}

export class ContributionDependent {
  MemberId: number;
  ZipCode: string;
  CountyCode: string;
  BirthDate: string;
  Age: number;
  StateId: number;
  IsTobaccoUser: boolean;
  IsLifeOnly: boolean;
  IsCobra: boolean;
  ParentId: number;
  EnrollmentEffectiveDate: string;
}

export class PlanRatingRequest {
  UniqueKey: string;
  IsBackRequest: boolean;
  StartingIndex: number;
  PlansRequested: number;
  IsOOSPlansRequested: number;
  EffectiveDate: string;
  CarrierId: number;
  CarrierName: string;
  NetworkIds: string;
  ERZipCode: string;
  ERCountyCode: string;
  ERStateId: number;
  CoverageTypeId: number;
  BundleTypeId: number;
  ClassificationTypeId: number;
  SicCode: string;
  IsWrappedCarrier: boolean;
  Employees: ContributionMember[];
  NonCobraEmployeesCount: number;
  PlanIds: string;
  CurrentPlanIds: string;
  CurrentPackageRulesInstanceId: number;
  WrappedCarriers: any[];
  UserRole: string;
}